import { IconBrandApple, IconBrandGooglePlay } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import ShareCardModal, { MEDIA_SIZE } from '@modals/Share/ShareCardModal';

import { APP_STORE_URL, PLAY_STORE_URL, downloadLinkDisplay, downloadLinkUrl } from '../../constants/stores';
import AppMark from '../AppMark';

function openWindow(href) {
    window.open(href, '_blank', 'noopener,noreferrer');
}

/**
 * DownloadAppModal — the share card named for the app itself: the app mark,
 * the name and a QR code that sends a phone to its own store. The channels
 * are the two store pages plus copy / WhatsApp, so the link can also be sent
 * to the phone by hand. Everything else (stage, card, QR) is ShareCardModal's.
 */
export default function DownloadAppModal({ open, onClose }) {
    const { t } = useTranslation('common');

    return (
        <ShareCardModal
            open={open}
            onClose={onClose}
            url={downloadLinkUrl()}
            displayUrl={downloadLinkDisplay()}
            title={t('downloadApp.title')}
            subtitle={t('downloadApp.subtitle')}
            shareText={t('downloadApp.shareText')}
            fileSlug="app"
            palette={false}
            channels={[
                { id: 'ios', icon: <IconBrandApple />, label: 'App Store', onClick: () => openWindow(APP_STORE_URL) },
                { id: 'android', icon: <IconBrandGooglePlay />, label: 'Google Play', onClick: () => openWindow(PLAY_STORE_URL) },
                'copy',
                'whatsapp',
            ]}
            card={{
                media: <AppMark size={MEDIA_SIZE} />,
                name: 'Ginastee',
                caption: t('downloadApp.caption'),
                shape: 'squircle',
            }}
        />
    );
}
